const mutations = {
  setPageConfig(state, payload) {
    state.pageConfig = payload
  },
  setExtraFields(state, payload) {
    state.extraFields = payload
  },
  checkYiXunDa(state, payload) {
    state.isYiXunDa = payload
  },
  setBatchRowData(state, payload) {
    state.batchRowData = payload
  },
  setOrderRowData(state, payload) {
    state.orderRowData = payload
  },
  setManualTrackingNumbers(state, payload) {
    state.manualTrackingNumbers = payload
  },
  setOrderListTable(state, payload) {
    state.orderListTable = payload
  },
  setOrderListConditions(state, payload) {
    state.orderListConditions = payload
  },
  setOrderListSearchMore(state, payload) {
    state.orderListSearchMore = payload
  },
  SAVEBATCHID (state,payload) {
    state.saveid = payload
  },
  SAVEBATCHLIST(state,payload) {
    state.savebatchList = payload
  },
  saveyitiqulist(state,payload) {
    state.saveyitiqulist = payload
  },
  saveqslist(state,payload) {
    state.saveqslist = payload
  },
  savewqslist(state,payload) {
    state.savewqslist = payload
  }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js